import { SendQuestionFeedbackCommand } from "./../models/preplabModels";
import { useFetchPostApiData } from "./useFetchPostApiData";

export const useSendFeedback = () => {
    return useFetchPostApiData<SendQuestionFeedbackCommand, null>("/api/TestSession/SendQuestionFeedback");
};
